import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
console.log("This is the base URL", API_BASE_URL);

export interface Agency {
  id: number;
  userId: number;
  name: string;
  lastName: string;
  agencyName: string;
  phone1: string;
  phone2: string;
  mobile: string;
  mobile2: string;
  fax: string;
  vat: string;
  rea: string;
  registeredOffice: string;
  businessRegisterProvince: string;
  pec: string;
  website: string;
  email: string;
  codicefiscale: string;
  ragioneSociale: string;
  socialCapital: string;
  soleProprietorship: number;
  address_details: {
    address: string;
    city_name: string;
    city_cap: number;
    province_name: string;
    sigla: string;
  }
}

export const useGetAgencyDetails = (agencyId: number) => {
  const [agency, setAgency] = useState<Agency | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!agencyId) return; // Evita richieste con ID non valido

    const fetchAgencyDetails = async () => {
      try {
        console.log("Sending request to",`${API_BASE_URL}/agency`)
        const response = await axios.post(`${API_BASE_URL}/agency`, {
          agencyId,
          limit: 10,
          offset: 0,
        });

        console.log("Response:", response.data);
        setAgency(response.data.data);
      } catch (err) {
        console.error("Error fetching agency details:", err);
        setError("Failed to fetch agency details");
      } finally {
        setLoading(false);
      }
    };

    fetchAgencyDetails();
  }, [agencyId]);

  return { agency, loading, error };
};